import { ConditionalBehavior } from '../behavior';
import { Injectable } from '@angular/core';
import { BehaviorContext } from '../behavior-context';
import { GLOBAL_KEY_APPROVE_ME_FUNDING_APP } from '../behaviors/approve.me/constants';

@Injectable()
export class ShouldShowNextPayDateBehavior extends ConditionalBehavior {
  async execute(
    args: { [key: string]: any },
    context: BehaviorContext
  ): Promise<boolean> {
    const app = context.get(GLOBAL_KEY_APPROVE_ME_FUNDING_APP);

    return (
      app.paymentFrequency == 'monthly' ||
      app.paymentFrequency === 'semi-monthly'
    );
  }
}
